import { useEffect, useState } from 'react'
import { FunnelIcon } from './Logo'

interface SplashScreenProps {
  show: boolean
}

export default function SplashScreen({ show }: SplashScreenProps) {
  const [visible, setVisible] = useState(show)
  const [fading, setFading] = useState(false)

  useEffect(() => {
    if (show) {
      setVisible(true)
      setFading(false)
    } else if (visible) {
      setFading(true)
      const t = setTimeout(() => setVisible(false), 500)
      return () => clearTimeout(t)
    }
  }, [show])

  if (!visible) return null

  return (
    <div className={`fixed inset-0 z-[99999] flex items-center justify-center bg-brand-950 transition-opacity duration-500 ${fading ? 'opacity-0' : 'opacity-100'}`}>
      <div className={`flex flex-col items-center transition-all duration-500 ${fading ? 'opacity-0 scale-105' : 'opacity-100 scale-100'}`}>
        <div className="mb-6 splash-pulse">
          <FunnelIcon className="w-20" light />
        </div>
        <span className="text-3xl font-bold text-white mb-8">
          S<span className="dotted-i">ı</span>spol<span className="dotted-i">ı</span>
        </span>
        <div className="w-6 h-6 border-2 border-white/20 border-t-white rounded-full animate-spin" />
      </div>
    </div>
  )
}
